import { render, staticRenderFns } from "./merchantSubjectInfo.vue?vue&type=template&id=3c12a506&scoped=true"
import script from "./merchantSubjectInfo.vue?vue&type=script&lang=js"
export * from "./merchantSubjectInfo.vue?vue&type=script&lang=js"
import style0 from "./merchantSubjectInfo.vue?vue&type=style&index=0&id=3c12a506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c12a506",
  null
  
)

export default component.exports